<div class="main pt-3">
  <div class="container " style="max-width: 1400px">
    <div class="row spacing-20">
      <div class="card p-0">
        <div class="card-header rounded-top bgi-size-cover position-relative" [style.background-image]="'url(' + company.header_image_url + ')'" style="background-position: 100% 50%; height: 300px">
          <app-button
            [variant]="'ghost'"
            [iconClass]="'fa fa-camera fs-2'"
            [size]="'lg'"
            class="position-absolute"
            style="top: 10px; right: 30px; z-index: 10; width: 35px; height: 35px; padding: 0;"
            (clicked)="openUpdateImageModal('header')"
          />
        </div>
        <div class="card-body mt-n19">
          <div class="m-0">
            <div class="d-flex flex-stack align-items-end pb-4 mt-n19">
              <div class="symbol symbol-125px symbol-lg-150px symbol-fixed position-relative mt-n3">
                @if (company.company_logo_url){
                  <img [src]="company.company_logo_url" alt="image" class="border border-white border-4" style="border-radius: 20px" />
                } @else {
                  <div
                    class="d-flex justify-content-center align-items-center border border-white border-4 bg-light"
                    style="border-radius: 20px; width: 100%; height: 100%; color: #555c61;"
                  >
                    <i class="fa-regular fa-building fs-7x m-5"></i>
                  </div>
                }
                <app-button
                  [variant]="'ghost'"
                  [iconClass]="'fa fa-camera'"
                  [size]="'sm'"
                  class="position-absolute"
                  style="bottom: 3px; right: 25px; width: 35px; height: 35px; border-radius: 50%; padding: 0;"
                  (clicked)="openUpdateImageModal('logo')"
                />
              </div>
            </div>
            <div class="d-flex flex-stack flex-wrap align-items-end">
              <div class="d-flex flex-column">
                <div class="d-flex align-items-center mb-2">
                  <a href="#" class="text-gray-800 text-hover-primary fs-2 fw-bolder me-1">{{ company.company_name}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row ">
      <div id="kt_user_profile_nav" class="rounded bg-gray-200 d-flex flex-stack flex-wrap mb-9 p-2" style="background-color: lightgrey" data-kt-sticky="false" data-kt-sticky-name="sticky-profile-navs" data-kt-sticky-offset="{default: false, lg: '200px'}" data-kt-sticky-width="{target: '#kt_user_profile_panel'}" data-kt-sticky-left="auto" data-kt-sticky-top="70px" data-kt-sticky-animation="false" data-kt-sticky-zindex="95">
        <ul class="nav flex-wrap border-transparent">
          <li class="nav-item my-1">
            <a class="btn btn-sm btn-color-gray-600 bg-state-body btn-active-color-gray-800 fw-bolder fw-bold fs-6 fs-lg-base nav-link px-3 px-lg-4 mx-1" [ngClass]="{ 'active': selectedTab === 'information' }" (click)="selectedTab = 'information'">Information</a>
          </li>
          <li class="nav-item my-1">
            <a class="btn btn-sm btn-color-gray-600 bg-state-body btn-active-color-gray-800 fw-bolder fw-bold fs-6 fs-lg-base nav-link px-3 px-lg-4 mx-1" [ngClass]="{ 'active': selectedTab === 'events' }" (click)="selectedTab = 'events'">Events</a>
          </li>
          <li class="nav-item my-1">
            <a class="btn btn-sm btn-color-gray-600 bg-state-body btn-active-color-gray-800 fw-bolder fw-bold fs-6 fs-lg-base nav-link px-3 px-lg-4 mx-1" [ngClass]="{ 'active': selectedTab === 'contact' }" (click)="selectedTab = 'contact'">Contact</a>
          </li>
          <li class="nav-item my-1">
            <a class="btn btn-sm btn-color-gray-600 bg-state-body btn-active-color-gray-800 fw-bolder fw-bold fs-6 fs-lg-base nav-link px-3 px-lg-4 mx-1" [ngClass]="{ 'active': selectedTab === 'memberships' }" (click)="selectedTab = 'memberships'">Membership Plans</a>
          </li>
          <li class="nav-item my-1">
            <a class="btn btn-sm btn-color-gray-600 bg-state-body btn-active-color-gray-800 fw-bolder fw-bold fs-6 fs-lg-base nav-link px-3 px-lg-4 mx-1" [ngClass]="{ 'active': selectedTab === 'admin' }" (click)="selectedTab = 'admin'">User Administration</a>
          </li>
        </ul>
      </div>
    </div>
    @if (selectedTab == 'information') {
      <app-company-profile-overview
        [company]="company"
      />
    }
    @else if (selectedTab == 'contact') {
      <p>Contact work</p>
    }
    @else if (selectedTab == 'events') {
      <app-company-profile-events
        [company]="company"
      />
    }
    @else if (selectedTab == 'memberships') {
      <app-company-profile-membership-plans
        [company]="company"
      />
    }
    @else if (selectedTab == 'admin') {
      <p>Admin work</p>
    }
  </div>
</div>
